import FirstPasswordForm from './FirstPasswordForm'

export default FirstPasswordForm
